import { useMemo } from 'react';
import { CardContent } from '@mui/material';
import { Edit, Form, Toolbar, useEditController } from 'react-admin';
import type { MissionSummary } from '@wwf/sdk';
import { missionSummaryToInput } from '@domain/mission';
import { MissionInputs } from './MissionInputs';

export const MissionEdit = () => {
    const { record } = useEditController<MissionSummary>();
    const formRecord = useMemo(
        () => (record ? missionSummaryToInput(record) : undefined),
        [record]
    );

    return (
        <Edit actions={false} redirect="show" mutationMode="pessimistic">
            <Form record={formRecord}>
                <CardContent>
                    <MissionInputs />
                </CardContent>
                <Toolbar />
            </Form>
        </Edit>
    );
};
